import api from "../../../../../api/axios"

/**
 * Returns the saved account's data, or false on failure (unchanged).
 *
 * Optional onError({ status, message }) lets the caller show the reason and
 * react to it: 400 = wrong code (try again), 401 = verification expired,
 * 429 = too many attempts (both: start over).
 */
export default async function submitBankAccount(reimbursementForm, { onError } = {}) {
    try {
        const { bank, bankName, nickname, accountNumber, accountType, code, challengeToken } = reimbursementForm

        const payload = {
            routingNumber: bank?.routingNumber,
            bankName,
            nickname,
            accountNumber,
            accountType,
            code,
            challengeToken,
        }

        // One account per user: the same route adds or changes it, no id.
        const url = "user/bankAccount"
                
        const response = await api.post(url, payload)
        if (response.data.error) {
            // Legacy path reports failure as 200 + { error }
            onError?.({ status: 200, message: response.data.error })
            return false;
        }
        return response?.data
    } catch (error) {
        console.error(error)
        onError?.({
            status: error?.response?.status,
            message: error?.response?.data?.message || "Failed to save bank account",
        })
        return false;
    }
}
